import Strings from "../core/data/Strings";
import ResizableScene from "../core/ResizableScene";
import ScaleManager from "../core/ScaleManager";
import Fonts from "../utils/Fonts";
import GameColors from "../utils/GameColors";

export default class GameCompleteScene extends ResizableScene {
	private _onResize: () => void;

	create(): void {
		super.create();

		const background = this.add.image(0, 0, "whiteSquare");

		const headerText = this.add.text(0, 0, Strings.get("GameComplete"), {
			fontSize: "64px",
			color: GameColors.BLACK,
			fontFamily: Fonts.Arial,
			wordWrap: {width: 800},
			align: "center",
		});

		const backButton = this.add.button(0, 0, "backBtn", null, this.back, this);

		this._onResize = (): void => {
			ScaleManager.ScaleBackgroundFromZone(background, this.viewport);
			this.alignIn.Center(background, this.viewport);
			this.alignIn.Center(headerText, this.viewport, 0, 0);
			this.alignIn.TopLeft(backButton, this.viewport, -40, -40);
		};
		this.resize();
	}

	shutdown(): void {
		this._onResize = null;
		super.shutdown();
	}

	resize(): void {
		super.resize();
		if (this._onResize != null) this._onResize();
	}

	back(): void {
		this.scene.start("LevelSelectScene");
	}
}
